import { all, call, fork, put, takeEvery } from 'redux-saga/effects';

import { customHeaders, supersetUrl } from '../../../../../../Containers/Config/index.js';
import { SUPERSET_AINA_CONTRIBUTION, SUPERSET_AINA_CONTRIBUTION_ERROR, SUPERSET_AINA_CONTRIBUTION_SUCCESS } from '../../../../actionType.js';
import apiCall from '../../../../apiCall.js';

function* supersetAINAContribution({ payload }) {
  try {
    const filteredHeaders = { ...customHeaders };
    delete filteredHeaders['X-Requested-By'];

    const response = yield call(apiCall, {
      url: `${supersetUrl}/api/v1/chart/data`,
      method: 'POST',
      headers: {
        ...filteredHeaders,
        ...payload?.headers,
      },
      data: payload?.data,
    });

    if (response.status === 200) {
      yield put({
        type: SUPERSET_AINA_CONTRIBUTION_SUCCESS,
        payload: response?.data,
      });
    } else {
      yield put({
        type: SUPERSET_AINA_CONTRIBUTION_ERROR,
        payload: response.data.message,
      });
    }
  } catch (error) {
    yield put({ type: SUPERSET_AINA_CONTRIBUTION_ERROR, payload: error });
  }
}

export function* watchSupersetAINAContribution() {
  yield takeEvery(SUPERSET_AINA_CONTRIBUTION, supersetAINAContribution);
}

function* supersetAINAContributionSaga() {
  yield all([fork(watchSupersetAINAContribution)]);
}

export default supersetAINAContributionSaga;
